module.exports = __webpack_public_path__ + "img/pålestikk_ferdig.2e45c186.jpg";